import { render, staticRenderFns } from "./HotelServiceModal.vue?vue&type=template&id=6308644c&"
import script from "./HotelServiceModal.vue?vue&type=script&lang=js&"
export * from "./HotelServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./HotelServiceModal.vue?vue&type=style&index=0&id=6308644c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports